// TODO: Import React module
import * as React from 'react';
import { useNavigate } from 'react-router-dom';

// TODO: Import MUI module;
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

// TODO: Import MUI icon;
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import InstagramIcon from '@mui/icons-material/Instagram';

// TODO: Import custom component

export default function MenuBar() {
    // TODO: Define useContext

    // TODO: Define variable
    const drawerWidth = 240;
    const navItems = [
        {
            title: '貽園小知識',
            hash: 'GridKnowledge',
        }, {
            title: '活動剪影',
            hash: 'GridActivities',
        }, {
            title: '實景導覽',
            hash: 'GridFloorplan',
        }, {
            title: '植物資訊',
            hash: 'GridPlant',
        }, {
            title: '智慧莊園',
            hash: 'GridEGarden',
        }, {
            title: '科技應用',
            hash: 'GridTech',
        }
    ];

    const [mobileOpen, setMobileOpen] = React.useState(false);

    // TODO: Define event
    const navigate = useNavigate();

    const handleDrawerToggle = () => {
        setMobileOpen((prevState) => !prevState);
    };

    const drawer = (
        <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
            <Box
                component="img"
                src="https://www.pohtyh.edu.hk/YiYuan/images/logo.png"
                sx={{ display: { xs: 'none', md: 'inline-block' } }}
            />
            <Typography variant="h6" sx={{ my: 2 }}>貽園</Typography>
            <Divider />
            <List>
                {navItems.map((item) => (
                    <ListItem key={item.title} disablePadding>
                        <ListItemButton
                            onClick={() => {
                                navigate('/#' + item.hash);
                            }}
                            sx={{ textAlign: 'center' }}
                        >
                            <ListItemText primary={item.title} />
                        </ListItemButton>
                    </ListItem>
                ))}
                <ListItem disablePadding>
                    <ListItemButton sx={{ textAlign: 'center' }}>
                        <ListItemText>
                            <IconButton
                                href="https://www.facebook.com/profile.php?id=100057508146641"
                                target="_blank"
                            >
                                <FacebookOutlinedIcon />
                            </IconButton>
                            <IconButton
                                href="https://www.instagram.com/tyh.yi.yuan/"
                                target="_blank"
                            >
                                <InstagramIcon />
                            </IconButton>
                        </ListItemText>
                    </ListItemButton>
                </ListItem>
            </List>
        </Box>
    );

    // TODO: Define function

    // TODO: Return component
    return (
        <>
            <AppBar color="success" component="nav">
                <Toolbar id="Toolbar">
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{ mr: 2, display: { md: 'none' } }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Box
                        component="img"
                        src="https://www.pohtyh.edu.hk/YiYuan/images/logo.png"
                        sx={{ display: { xs: 'none', md: 'inline-block' } }}
                    />
                    <Typography
                        variant="h6"
                        component="div"
                        sx={{
                            display: { xs: 'none', md: 'block' },
                            flexGrow: 1,
                            ml: 1,
                        }}
                    >
                        貽園
                    </Typography>
                    <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                        <>
                            {navItems.map((item) => (
                                <Button
                                    key={item.title}
                                    onClick={() => {
                                        navigate('/#' + item.hash);
                                    }}
                                    sx={{ color: '#fff' }}
                                >
                                    {item.title}
                                </Button>
                            ))}
                            <IconButton
                                href="https://www.facebook.com/profile.php?id=100057508146641"
                                target="_blank"
                                sx={{ color: 'white' }}
                            >
                                <FacebookOutlinedIcon />
                            </IconButton>
                            <IconButton
                                href="https://www.instagram.com/tyh.yi.yuan/"
                                target="_blank"
                                sx={{ color: 'white' }}
                            >
                                <InstagramIcon />
                            </IconButton>
                        </>
                    </Box>
                </Toolbar>
            </AppBar>
            <Box component="nav">
                <Drawer
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        display: { xs: 'block', md: 'none' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                    }}
                >
                    {drawer}
                </Drawer>
            </Box>
            <Toolbar id="TopAnchor" />
        </>
    );
}